import { cx } from "@/utils";
import Ellipsis from "./ellipsis";
import PaginationButton from "./pagination-button";

export default function PageButton({ page, currentPage, ...props }) {
  if (page === "...") {
    return <Ellipsis />;
  }
  return (
    <PaginationButton
      className={cx("text-black", currentPage === page && "bg-cp-grey-200")}
      page={page}
      {...props}
    >
      {page}
    </PaginationButton>
  );
}
